/* eslint-disable no-unused-vars */
import BaseMiddleware from './BaseMiddleware'
import store from '@/store'

export default class AuthMiddleware extends BaseMiddleware {
    /**
     * Avalia se deve executar este middleware ou não
     *
     * @param {Route} to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve executar este middleware?
     */
    shouldRun(to, _from) {
        return to.meta.requiresAuth
    }

    /**
     * Executa ações sobre esta rota
     *
     * @param {Route} _to de qual rota está vindo
     * @param {Route} _from para qual rota está indo
     *
     * @return {boolean} deve retornar false quando este middleware modifica a rota com next
     */
    handle(_to, _from, next) {
        let isAuthenticated = store.getters['auth/token']
        if (!isAuthenticated) {
            next({ name: 'login' })
        }

        return true
    }
}
